import type { ChangeEvent } from 'react';
import { type Path, type PathValue, type FieldValues, useFormContext } from 'react-hook-form';

import { Checkbox } from '@ctct/payflow-ui';

import { Field } from './Field';
import { useFormLoadingContext } from './FormLoadingContext';
import { errorAdapter } from './helpers';
import type { PropsBase } from './types';

type Props<T extends FieldValues> = PropsBase<T>;

export function FormFieldCheckboxNonFekit<T extends FieldValues>({
  label,
  name,
  qeId,
  optional,
  placeholder,
  disableMarginBottom,
}: Props<T>) {
  const id = `form-field-${name}`;
  const isLoading = useFormLoadingContext();

  const {
    formState: { errors },
    watch,
    setValue,
  } = useFormContext<T>();

  const error = errors[name];
  const value = watch(name);

  return (
    <Field
      data-qe-id={qeId}
      label=""
      labelFor={id}
      error={errorAdapter(error)}
      category={optional ? 'optional' : undefined}
      style={{ marginBottom: disableMarginBottom ? 0 : undefined }}
    >
      {isLoading ? null : (
        <>
          <Checkbox
            id={id}
            name={name}
            data-qe-id={qeId.concat('-checkbox')}
            label={label}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setValue(name, e.target.checked as PathValue<T, Path<T>>, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
              })
            }
            checked={value}
          />
          {placeholder && <span className="payflow-form-field__placeholder">{placeholder}</span>}
        </>
      )}
    </Field>
  );
}
